<template>
    <div class="home-banner">
        <div class="home_nav-wrapper">
            <div class="m_nav_wrapper">
                <i class="iconfont menu-icon" @click="showMenu">&#xe673;</i>
                <a id="logo" href="/">
                    <img src="../../assets/images/m_nav_logo@3x.png"/>
                </a>
                <div id="login" @click="goMyPage">
                    <i class="iconfont personal-icon">&#xe672;</i>
                </div>
            </div>
            <sider-menu v-show="showmenu" @showmenu="showMenu"></sider-menu>
        </div>
        <slot name="topbanner" ></slot>
  </div>
        
</template>

<script>
import SiderMenu from '@/components/modules/SiderMenu';
export default {
    props:{
        title:"",
        path:"",
        redirect:{
            type:Boolean,
            default:false
        },
    },
    data(){
        return{
            showmenu:false,
        }
    },
   
    methods:{
        goMyPage(){
            this.$router.push({name:"my",query: { redirect: this.redirect }})
        },
        showMenu(){
            this.showmenu = !this.showmenu ;
            if(this.showmenu){
                document.documentElement.classList = 'menu-lock-hide';
            }else{
                document.documentElement.classList = '';
            }
        }

    },
    components:{
        SiderMenu
    },
    

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/modules/HomeNav.vue